import { render, staticRenderFns } from "./SendProposalModal.vue?vue&type=template&id=3d1c3f1f&"
import script from "./SendProposalModal.vue?vue&type=script&lang=js&"
export * from "./SendProposalModal.vue?vue&type=script&lang=js&"
import style0 from "./SendProposalModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports